import React, { useEffect, useState } from "react";
import { useParams } from "react-router";

import { Row, Table } from "antd";

import Text from "antd/lib/typography/Text";

import Loader from "components/Loader/Loader";

import { fetchSurveyResponseListApi } from "utils/apiService";
import { formatTimeStr } from "antd/lib/statistic/utils";

const SurveyResponses = (props) => {
  const [loading, setLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(true);
  const [responseList, setResponseList] = useState({
    responses: [],
    pageNum: 1,
    pageSize: 50,
    totalPages: 1,
  });

  const { formID } = useParams();
  const loadTable = () => {
    // setLoading(true);
    setTableLoading(true);
    fetchSurveyResponseListApi({
      requestData: {
        uuid: formID,
        page: responseList.pageNum,
      },
      resCallback: () => {
        loading && setLoading(false);
        setTableLoading(false);
      },
      res200Callback: (res) => {
        setResponseList({
          ...responseList,
          responses: res.data.response_list,
          totalPages: res.data.total_pages,
        });
      },
    });
  };
  useEffect(() => {
    loadTable();
  }, [responseList.pageNum]);

  const columns = [
    {
      title: "Submitted By",
      dataIndex: ["name", "contact_number"],
      key: "raisedBy",
      render: (_, row) => {
        return (
          <Row type="flex" style={{ flexDirection: "column" }}>
            <Text
              style={{
                fontStyle: "normal",
                fontWeight: "bold",
                fontSize: "16px",
                lineHeight: "24px",
                color: "#181818",
                whiteSpace: "nowrap",
              }}
            >
              {row.name ? row.name : "-"}
            </Text>
            {row.contact_number ? (
              <Text
                style={{
                  fontStyle: "normal",
                  fontSize: "14px",
                  lineHeight: "24px",
                }}
              >
                {row.contact_number}
              </Text>
            ) : null}
          </Row>
        );
      },
    },
    {
      title: "Reward Card No.",
      dataIndex: "reward_card_number",
      key: "rewardCardNumber",
      render: (rewardCardNumber) => (
        <Text
          style={{
            fontStyle: "normal",
            fontSize: "16px",
            lineHeight: "24px",
            fontWeight: "bold",
            color: "#181818",
          }}
        >
          {rewardCardNumber ? rewardCardNumber : ""}
        </Text>
      ),
    },
    {
      title: "Recommendation Score",
      dataIndex: "recommendation_score",
      key: "recommendationScore",
      render: (recommendationScore) => (
        <Text
          style={{
            fontStyle: "normal",
            fontSize: "16px",
            lineHeight: "24px",
            fontWeight: "bold",
            color: "#181818",
          }}
        >
          {recommendationScore ? recommendationScore : ""}
        </Text>
      ),
    },
    {
      title: "Submitted On",
      dataIndex: "submitted_on",
      key: "submittedOn",
      render: (submittedOn) => (
        <div style={{ width: "135px" }}>{submittedOn}</div>
      ),
    },
  ];

  return loading ? (
    <Row
      type="flex"
      align="middle"
      justify="center"
      style={{ marginTop: "200px" }}
    >
      <Loader />
    </Row>
  ) : (
    <Table
      columns={columns}
      dataSource={responseList.responses}
      pagination={{
        pageSize: responseList.pageSize,
        current: responseList.pageNum,
        total: responseList.pageSize * responseList.totalPages,
      }}
      onChange={(pagination) =>
        setResponseList({ ...responseList, pageNum: pagination.current })
      }
      loading={tableLoading}
      onRow={(obj) => ({
        onClick: () =>
          props.history.push(`/app-feedback/${formID}/response/${obj.uuid}`),
      })}
    />
  );
};

export default SurveyResponses;
